module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "zdy-table",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.msgSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "titleCon"
  }, [_c('img', {
    attrs: {
      "src": _vm.titleImg
    }
  }), _vm._v(" "), _c('card', {
    staticClass: "numItem"
  }, [_c('div', {
    staticClass: "card-demo-flex card-demo-content01",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "vux-1px-r"
  }, [_c('span', [_c('countup', {
    staticClass: "fontUp",
    attrs: {
      "start-val": 0,
      "end-val": _vm.passedNum,
      "duration": 2
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v("\n            条建议已通过\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-r"
  }, [_c('span', [_c('countup', {
    staticClass: "fontUp",
    attrs: {
      "start-val": 0,
      "end-val": _vm.acceptNum,
      "duration": 2
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v("\n            条建议已采纳\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-r"
  }, [_c('span', [_c('countup', {
    staticClass: "fontUp",
    attrs: {
      "start-val": 0,
      "end-val": _vm.implmentNum,
      "duration": 2
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v("\n            条建议已实现\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-r"
  }, [_c('span', [_c('countup', {
    staticClass: "fontUp",
    attrs: {
      "start-val": 0,
      "end-val": _vm.solveNum,
      "duration": 2
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v("\n            条建议已解决\n          ")])])])], 1), _vm._v(" "), _c('group', [_c('popup-radio', {
    attrs: {
      "title": _vm.sayTitle,
      "options": _vm.saylist,
      "placeholder": "请选择"
    },
    on: {
      "on-hide": _vm.sayclick
    },
    model: {
      value: (_vm.sayvalue),
      callback: function($$v) {
        _vm.sayvalue = $$v
      },
      expression: "sayvalue"
    }
  }), _vm._v(" "), _c('popup-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nullshow),
      expression: "nullshow"
    }],
    attrs: {
      "title": "",
      "options": _vm.nulllist,
      "placeholder": _vm.nullplaceholder
    },
    model: {
      value: (_vm.nullvalue),
      callback: function($$v) {
        _vm.nullvalue = $$v
      },
      expression: "nullvalue"
    }
  }), _vm._v(" "), _c('x-textarea', {
    attrs: {
      "placeholder": "请输入您想对我们说的话",
      "autosize": ""
    },
    model: {
      value: (_vm.textareaValue),
      callback: function($$v) {
        _vm.textareaValue = $$v
      },
      expression: "textareaValue"
    }
  })], 1), _vm._v(" "), _c('group', [_c('popup-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needshow),
      expression: "needshow"
    }],
    attrs: {
      "title": "是否需要回复",
      "options": _vm.replylist,
      "placeholder": "请选择"
    },
    on: {
      "on-hide": _vm.needclick
    },
    model: {
      value: (_vm.replyvalue),
      callback: function($$v) {
        _vm.replyvalue = $$v
      },
      expression: "replyvalue"
    }
  }), _vm._v(" "), (_vm.staffShow) ? _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needTellshow),
      expression: "needTellshow"
    }],
    attrs: {
      "title": "科室",
      "placeholder": "请输入",
      "required": "",
      "text-align": "right"
    },
    model: {
      value: (_vm.officesValue),
      callback: function($$v) {
        _vm.officesValue = $$v
      },
      expression: "officesValue"
    }
  }) : _vm._e(), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needTellshow),
      expression: "needTellshow"
    }],
    attrs: {
      "title": "姓名",
      "placeholder": "请输入",
      "required": "",
      "text-align": "right"
    },
    model: {
      value: (_vm.nameValue),
      callback: function($$v) {
        _vm.nameValue = $$v
      },
      expression: "nameValue"
    }
  }), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needTellshow),
      expression: "needTellshow"
    }],
    attrs: {
      "title": "联系电话",
      "placeholder": "请输入",
      "is-type": _vm.typeZDY,
      "type": "number",
      "required": "",
      "text-align": "right"
    },
    model: {
      value: (_vm.needtelValue),
      callback: function($$v) {
        _vm.needtelValue = $$v
      },
      expression: "needtelValue"
    }
  }), _vm._v(" "), _c('cell', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hospitalshow),
      expression: "hospitalshow"
    }],
    attrs: {
      "value-align": "left"
    }
  }, [_vm._v("\n      锦欣生殖的发展离不开您最真诚的建议，非常感谢您的积极参与院区整改！您的整改建议一经采纳，我们将为您送上精美礼品送以表心意~请您留下联系方式便于稍后我院工作人员与您联系！\n    ")]), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hospitalshow),
      expression: "hospitalshow"
    }],
    attrs: {
      "title": "姓名",
      "placeholder": "请输入",
      "required": "",
      "text-align": "right"
    },
    model: {
      value: (_vm.nameValue),
      callback: function($$v) {
        _vm.nameValue = $$v
      },
      expression: "nameValue"
    }
  }), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hospitalshow),
      expression: "hospitalshow"
    }],
    attrs: {
      "is-type": _vm.typeZDY,
      "title": "联系电话",
      "placeholder": "请输入",
      "type": "number",
      "required": "",
      "text-align": "right"
    },
    model: {
      value: (_vm.telValue),
      callback: function($$v) {
        _vm.telValue = $$v
      },
      expression: "telValue"
    }
  })], 1), _vm._v(" "), _c('flexbox', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "gutter": 0,
      "wrap": "wrap"
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('flexbox-item', {
      key: index,
      attrs: {
        "span": 1 / 3
      }
    }, [_c('div', {
      staticClass: "flex-demo"
    }, [_c('svg', {
      staticClass: "vux-x-icon vux-x-icon-ios-close icon-red",
      attrs: {
        "type": "ios-close",
        "size": "30",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "30",
        "height": "30",
        "viewBox": "0 0 512 512"
      },
      on: {
        "click": function($event) {
          _vm.deleImgClick(index, _vm.list)
        }
      }
    }, [_c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0s81.2-213 0-294.2zM352 340.2L340.2 352l-84.4-84.2-84 83.8-11.8-11.8 84-83.8-84-83.8 11.8-11.8 84 83.8 84.4-84.2 11.8 11.8-84.4 84.2 84.4 84.2z"
      }
    })]), _vm._v(" "), _c('img', {
      staticClass: "previewer-demo-img",
      attrs: {
        "src": item.src,
        "width": "100"
      },
      on: {
        "click": function($event) {
          _vm.show(index)
        }
      }
    })])])
  }), _vm._v(" "), _vm._l((_vm.videoList), function(item, index) {
    return _c('flexbox-item', {
      key: index,
      staticStyle: {
        "position": "relative"
      },
      attrs: {
        "span": 1 / 3
      }
    }, [_c('div', {
      staticClass: "flex-demo",
      staticStyle: {
        "z-index": "5",
        "position": "relative"
      }
    }, [_c('div', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "left": "0",
        "right": "0px",
        "z-index": "8"
      },
      on: {
        "click": function($event) {
          _vm.videoDialog(item.src)
        }
      }
    }), _vm._v(" "), _c('svg', {
      staticClass: "vux-x-icon vux-x-icon-ios-close icon-red",
      attrs: {
        "type": "ios-close",
        "size": "30",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "30",
        "height": "30",
        "viewBox": "0 0 512 512"
      },
      on: {
        "click": function($event) {
          _vm.deleImgClick(index, _vm.videoList)
        }
      }
    }, [_c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0s81.2-213 0-294.2zM352 340.2L340.2 352l-84.4-84.2-84 83.8-11.8-11.8 84-83.8-84-83.8 11.8-11.8 84 83.8 84.4-84.2 11.8 11.8-84.4 84.2 84.4 84.2z"
      }
    })]), _vm._v(" "), _c('video', {
      attrs: {
        "controls": "controls",
        "preload": "auto",
        "webkit-playsinline": "false",
        "playsinline": "false",
        "x-webkit-airplay": "true",
        "x5-video-player-type": "h5",
        "x5-video-player-fullscreen": "true",
        "x5-video-ignore-metadata": "true"
      }
    }, [_c('source', {
      attrs: {
        "src": item.src,
        "type": "video/mp4; codecs=\"avc1.42E01E, mp4a.40.2\""
      }
    }), _vm._v("\n          你的浏览器不支持H5播放器\n      ")])])])
  }), _vm._v(" "), _c('flexbox-item', {
    attrs: {
      "span": 1 / 3
    }
  }, [_c('div', {
    staticClass: "flex-demo"
  }, [_c('div', {
    staticClass: "select tc"
  }, [_c('label', {
    attrs: {
      "for": "upload"
    }
  }, [_vm._v("点击上"), _c('br'), _vm._v("传图片")]), _vm._v(" "), _c('input', {
    ref: "uploadref",
    attrs: {
      "type": "file",
      "id": "upload",
      "accept": "image/*,video/*"
    }
  })])])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.list,
      "options": _vm.options
    }
  }), _vm._v(" "), _c('x-dialog', {
    staticClass: "dialog-video",
    model: {
      value: (_vm.videoshow),
      callback: function($$v) {
        _vm.videoshow = $$v
      },
      expression: "videoshow"
    }
  }, [_c('div', {
    staticClass: "img-box"
  }, [(_vm.videosrc) ? _c('video', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "controls": "controls",
      "webkit-playsinline": "true",
      "playsinline": "true",
      "x-webkit-airplay": "true",
      "x5-video-player-type": "h5",
      "x5-video-player-fullscreen": "true",
      "x5-video-ignore-metadata": "true"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videosrc,
      "type": "video/mp4; codecs=\"avc1.42E01E, mp4a.40.2\""
    }
  }), _vm._v("\n          你的浏览器不支持H5播放器\n       ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "40px",
      "height": "40px",
      "border-radius": "45px",
      "background": "#fff",
      "position": "absolute",
      "right": "-30px",
      "top": "-30px",
      "z-index": "1001"
    },
    on: {
      "click": function($event) {
        _vm.videoshow = false
      }
    }
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-close-empty",
    attrs: {
      "type": "ios-close-empty",
      "size": "40",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "40",
      "height": "40",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M340.2 160l-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z"
    }
  })])])])], 1), _vm._v(" "), _c('check-icon', {
    staticClass: "zdyCheck",
    attrs: {
      "value": _vm.agreeItem
    },
    on: {
      "update:value": function($event) {
        _vm.agreeItem = $event
      }
    }
  }, [_vm._v("我已知晓建议/吐槽等内容将会公开，且未提交敏感信息。")]), _vm._v(" "), _c('x-button', {
    staticClass: "submitBtn",
    attrs: {
      "type": "primary",
      "disabled": _vm.msgSubmitdisabled
    },
    on: {
      "on-click": _vm.msgSubmit
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('toast', {
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  }, [_vm._v(_vm._s(_vm.toastTxt))]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24686a1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/ValuationProject/SystemSurvey.vue
// module id = mZQq
// module chunks = 5